module.exports = __webpack_public_path__ + "media/images/flags/16/Dominican-Republic-e935a496eb59c0d6c303952589ab4e3c.png";